import Vue from "vue";
const api_path = "/products";


export async function index(options, filter) {
  const { sortBy, sortDesc, page, itemsPerPage } = options;

  const response = await Vue.prototype.$http.get(`${api_path}`, {
    params: {
      orderBy: sortBy[0] ? sortBy[0] : "",
      sortDesc: sortDesc[0] ? sortDesc[0] : "",
      page,
      perPage: itemsPerPage,
      filter
    }
  });

  return response.data;
}

export async function show(id) {
  const response = await Vue.prototype.$http.get(`${api_path}/${id}`);

  return response.data;
}

export async function update(id, payload) {
  const response = await Vue.prototype.$http.put(`${api_path}/${id}`, payload);

  return response.data;
}

export async function create(payload) {
  const response = await Vue.prototype.$http.post(`${api_path}`, payload);

  return response.data;
}

export async function destroy(id) {
  const response = await Vue.prototype.$http.delete(`${api_path}/${id}`);

  return response.data;
}
